import { Chart as ChartJS, registerables } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(...registerables);

interface ParticipationCardProps {
  selectedTopic: string;
  setSelectedTopic: (value: string) => void;
  selectedUniversity?: string;
  totalUsers?: number;
  totalStudents?: number;
  totalNotCompleted?: number;
  isCompletedFilter?: boolean | undefined;
  participationPieCompleted?: number;
  participationPieNotCompleted?: number;
  participationPieTotal?: number;
}

const ParticipationCard = ({
  selectedTopic,
  setSelectedTopic,
  selectedUniversity = '',
  totalUsers = 0,
  totalStudents = 0,
  totalNotCompleted = 0,
  isCompletedFilter,
  participationPieCompleted = 0,
  participationPieNotCompleted = 0,
  participationPieTotal = 0,
}: ParticipationCardProps) => {
  // Filtr tanlanganida: "Yakunlanganlar" / "Yakunlanmaganlar" (jami qatnashganlar asosida)
  const useCompletedView = isCompletedFilter !== undefined;
  const total = useCompletedView ? participationPieTotal : totalStudents;
  const firstSegment = useCompletedView ? participationPieCompleted : totalUsers;
  const secondSegment = useCompletedView ? participationPieNotCompleted : totalNotCompleted;

  const notParticipatedPercentage = total > 0 ? ((secondSegment / total) * 100).toFixed(1) : '0';
  const participatedPercentage = total > 0 ? ((firstSegment / total) * 100).toFixed(1) : '0';

  const labels = useCompletedView
    ? ["Yakunlanganlar", "Jarayonda"]
    : ["Ishtirok etganlar", "Ishtirok etmaganlar"];

  const data = {
    labels,
    datasets: [
      {
        data: [firstSegment, secondSegment],
        backgroundColor: ['#10b981', '#ef4444'],
        borderWidth: 0,
        cutout: '60%'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 500,
      easing: 'easeOutQuart' as const
    },
    plugins: {
      legend: {
        display: false
      },
      // tooltip: {
      //   backgroundColor: '#1e293b',
      //   padding: 12,
      //   borderRadius: 8,
      //   titleColor: '#fff',
      //   bodyColor: '#fff',
      //   callbacks: {
      //     label: function (context: any) {
      //       const label = context.label || '';
      //       const value = context.parsed || 0;
      //       const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
      //       const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
      //       return `${label}: ${value.toLocaleString()} (${percentage}%)`;
      //     }
      //   }
      // }
      tooltip: {
        enabled: false
      }
    }
  };

  const legendData = [
    {
      color: 'green',
      label: labels[0],
      value: firstSegment.toLocaleString()
    },
    {
      color: 'red',
      label: labels[1],
      value: secondSegment.toLocaleString()
    },
  ];

  return (
    <div className="participation-card">
      <div className="participation-header">
        <h3>Ishtirok darajasi</h3>
      </div>
      <div className="circular-stats-large">
        <div className="chart-wrapper">
          <div className="center-percentage">
            <div className="percentage-value">{total.toLocaleString()}</div>
            <div className="percentage-label">{useCompletedView ? "Jami qatnashganlar" : "Jami"}</div>
          </div>
          <Doughnut data={data} options={options} />
        </div>
        <div className="circular-legend">
          {legendData.map((item, index) => (
            <div key={index} className="legend-item">
              <span className={`legend-dot ${item.color}`}></span>
              <span className="legend-label">{item.label}</span>
              <span className="legend-value">{item.value}</span>
            </div>
          ))}
        </div>
        <div className="participation-summary">
          <div className="summary-item">
            <div className="summary-label">{labels[1]}</div>
            <div className="summary-value">{notParticipatedPercentage}%</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <div className="summary-label">{labels[0]}</div>
            <div className="summary-value">{participatedPercentage}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipationCard;
